export function assertDefined<T>(value: T | null | undefined): asserts value is T {
  ensureDefined(value);
}

export function ensureDefined<T>(value: T | null | undefined): T {
  if (value == null || value == undefined) {
    throw new Error("Expected value to be defined");
  }

  return value;
}
